const IconHeaderClose = ({
  className = '',
  color = 'var(--neutral_7)',
  size = 20,
}: {
  className?: string;
  color?: string;
  size?: number;
}) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="343 6 20 20"
    fill="none"
  >
    <path
      d="M359.068 21.1829C359.126 21.241 359.172 21.3099 359.203 21.3858C359.235 21.4617 359.251 21.543 359.251 21.6251C359.251 21.7072 359.235 21.7885 359.203 21.8644C359.172 21.9403 359.126 22.0092 359.068 22.0673C359.009 22.1254 358.941 22.1714 358.865 22.2028C358.789 22.2343 358.707 22.2505 358.625 22.2505C358.543 22.2505 358.462 22.2343 358.386 22.2028C358.31 22.1714 358.241 22.1254 358.183 22.0673L353 16.8837L347.818 22.0673C347.7 22.1846 347.541 22.2505 347.375 22.2505C347.209 22.2505 347.05 22.1846 346.933 22.0673C346.816 21.95 346.75 21.791 346.75 21.6251C346.75 21.4593 346.816 21.3002 346.933 21.1829L352.117 16.0001L346.933 10.8173C346.816 10.7 346.75 10.541 346.75 10.3751C346.75 10.2093 346.816 10.0502 346.933 9.93292C347.05 9.81564 347.209 9.74976 347.375 9.74976C347.541 9.74976 347.7 9.81564 347.818 9.93292L353 15.1165L358.183 9.93292C358.3 9.81564 358.459 9.74976 358.625 9.74976C358.791 9.74976 358.95 9.81564 359.068 9.93292C359.185 10.0502 359.251 10.2093 359.251 10.3751C359.251 10.541 359.185 10.7 359.068 10.8173L353.884 16.0001L359.068 21.1829Z"
      fill={color}
    />
  </svg>
);

export default IconHeaderClose;
